import React from 'react'
import { TableOfContents } from './tableOfContents.layout'
import { ModernBlockProps } from '../modernBlocks/modernBlocks.state'
import { List } from 'immutable'

export const TableOfContentsWidget = (props: { blocks: List<ModernBlockProps>} ) =>
  <TableOfContents.Wrapper blocks={props.blocks} />
